<template>
  <div>
    <h5>{{ $t('filter.title') }}</h5>

    <b-form @submit.prevent="sendFilteredQuery">

      <b-row class="col-md-12 col-sm-12 no-padding-right col-lg-12 col-12" cols="1" cols-sm="1" cols-md="1" cols-lg="2">
        <b-col class="no-padding-right">
          <!--SALE DATE RANGE-->
          <b-form-group
            class="mr-4 w-100 mh-100"
            id="verified-group"
            :invalid-feedback="invalidSaleDate"
            :state="stateSaleDate"
            :label="$t('filter.by.sales.period')"
            label-for="sale-date"
          >
            <VueCtkDateTimePicker
              id="sale-date"
              :custom-shortcuts="defaultDatepickerShortcuts"
              v-model="saleFilters.dateRange"
              :max-date="maxDate"
              @is-hidden="applyDateRange"
              :no-clear-button="true"
              :error="!stateSaleDate"
              :autoClose="true"
              @validate="sendFilteredQuery"
              :hint="$t('pages.sales.date_hint')"
              :locale="$_languageCode"
              :format="dateFormat"
              :formatted="dateFormat"
              outputFormat="YYYY-MM-DDTHH:mmZ"
              :range="true"
            >
            </VueCtkDateTimePicker>
          </b-form-group>
        </b-col>
        <b-col class="no-padding-right">

          <!--PRODUCT TYPE-->
          <b-form-group
            id="product-type-group"
            :label="$t('filter.by.sales.product_type')"
            label-for="product-type"
          >
            <multiselect
              id="product-type"
              :select-label="$t('multiselect.select_label')"
              :deselect-label="$t('multiselect.deselect_label')"
              :selected-label="$t('multiselect.selected_label')"
              class="input-height"
              v-model="productType"
              :placeholder="$t('multiselect.placeholder', { field: $t('filter.by.sales.product_type_field').toLowerCase() })"
              :options="productTypes"
              track-by="type"
              label="name">
            </multiselect>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="d-flex justify-content-end">
        <b-button
          class="mb-2"
          @click="clearAllFilters"
          variant="primary">
          <b-icon icon="arrow-repeat"></b-icon>
          {{ $t('filter.reset_button') }}
        </b-button>
        <b-button
          class="mb-2 ml-3"
          type="submit"
          variant="success">
          <b-icon icon="check"></b-icon>
          {{ $t('filter.apply_button') }}
        </b-button>
      </div>

    </b-form>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import {VAT_RATE_TYPES, DEFAULT_DATEPICKER_SHORTCUTS, getDateFormat} from '@base/configs'
  import { mapState } from 'vuex'
  import moment from 'moment'

  export default {
    name: 'SalesFilter',

    components: {
      Multiselect
    },

    props: {
      start: {
        type: String,
        required: true
      },
      end: {
        type: String,
        required: true
      },
    },

    data () {
      return {
        productTypes: VAT_RATE_TYPES,
        defaultDatepickerShortcuts: DEFAULT_DATEPICKER_SHORTCUTS,
        saleFilters: { 
          dateRange: {
            start: this.start,
            end: this.end
          },
        },
        productType: null,
        invalidSaleDate: null,
      }
    },

    created () {
      this.productType = this.setDefaultProductType()
    },

    watch: {
      'saleFilters.dateRange'() {
        this.invalidSaleDate = null
      }
    },

    computed: {
      ...mapState(['customerData', 'userMarket']),

      dateFormat() {
        return getDateFormat(this.userMarket?.supportCountry?.code)
      },

      maxDate () {
        return moment().format('YYYY-MM-DD')
      },

      productTypeArg () {
        return this.productType ? this.productType.type : undefined
      },

      filterArgs () {
        return {
          dateStart: moment.parseZone(this.saleFilters.dateRange.start).format('YYYY-MM-DD'),
          dateEnd: moment.parseZone(this.saleFilters.dateRange.end).format('YYYY-MM-DD'),
          productType: this.productTypeArg
        }
      },
      
      isSaleDateValid () {
        if (!this.saleFilters.dateRange)
          return false
        return this.saleFilters.dateRange.start || this.saleFilters.dateRange.end
      },
      stateSaleDate () {
        return (this.invalidSaleDate === null)
      },
    },

    methods: {
      applyDateRange () {
        this.$nextTick(this.sendFilteredQuery)
      },

      setDefaultProductType () {
        if (this.customerData.customerType.length === 1) {
          return this.productTypes.find(
            obj => obj.type === Number(this.customerData.customerType[0])
          )
        }
        return null
      },

      clearAllFilters () {
        this.saleFilters = {
          dateRange: {
            start: this.start,
            end: this.end,
          },
        }
        this.productType = this.setDefaultProductType()
        this.$store.commit(this.$_mutationTypes.SET_SALE_LINES_FILTERS, this.filterArgs)
        this.$emit('filter-applied')
      },
      sendFilteredQuery () {
        if (!this.isSaleDateValid) {
          this.invalidSaleDate = this.$t('validation.date_range')
          return
        }
        this.$store.commit(this.$_mutationTypes.SET_SALE_LINES_FILTERS, this.filterArgs)
        this.$emit('filter-applied')
      }
    }
  }
</script>

<style>

</style>
